import React, { Fragment, useState } from "react";
import styled from "styled-components";
import {
  Grid,
  Typography,
  Dialog as MUIDialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";

import {
  CancelButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { useAxios } from "../../../hooks";
import { TextField } from "../../../components";
import { colors } from "../../css components/Style";
import { alert } from "../../../redux/slices/alertSlice";

// Styled Components
const StyledDialog = styled(MUIDialog)`
  .MuiDialog-paper {
    min-width: 400px;
  }
`;

const CenterDiv = styled.div`
  display: flex;
  text-align: center;
  justify-content: center;
`;

export default function OtpVerification({
  formikProps,
  verifyOTP,
  setVerifyOTP,
  brandID,
  setStep,
  setSignLoading,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const userID = sessionStorage.getItem("userID");

  const [loading, setLoading] = useState({
    resend: false,
    verify: false,
    send: false,
  });
  const [message, setMessage] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [aadharNumber, setAadharNumber] = useState();

  const { siteColors } = useSelector((state) => state.renderUIDetails);

  const handleClose = () => {
    setVerifyOTP(false);
  };

  function handleChange(e) {
    if (e.target.value?.toString().length > 6) return;
    setOtpValue(e.target.value);
  }

  function handleEnterAadharNumber(e) {
    if (e.target.value?.toString().length > 12) return;
    setAadharNumber(e.target.value);
  }

  return (
    <StyledDialog open={verifyOTP} onClose={handleClose}>
      <DialogTitle>
        <Typography color={siteColors?.primary} fontWeight="500" variant="h4">
          Sign agreement by Aadhaar OTP
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography color={colors.green} variant="subtitle1">
              Enter Aadhaar Number of Director/Signed Authority
            </Typography>
          </Grid>

          <Grid item xs={8}>
            <TextField
              size="small"
              placeholder="Enter Aadhaar Number"
              name="aadharNumber"
              label="Aadhar Number"
              value={aadharNumber}
              onChange={handleEnterAadharNumber}
              type="number"
              disabled={otpSent}
              InputProps={{
                endAdornment: otpSent && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setOtpValue("");
                        setOtpSent(false);
                      }}
                      style={{ padding: 0 }}
                    >
                      <Edit style={{ color: siteColors?.primary }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {otpSent && (
            <Fragment>
              <Grid item xs={12}>
                <Typography color={colors.green} variant="subtitle1">
                  Enter OTP sent on linked mobile number
                </Typography>
              </Grid>

              <Grid item xs={8}>
                <TextField
                  formikProps={formikProps}
                  type="number"
                  onChange={handleChange}
                  value={otpValue}
                  name="otpValue"
                  size="small"
                  label="Enter OTP"
                  placeholder="Enter OTP"
                />
              </Grid>

              <Grid item xs={12}>
                <Typography>{message}</Typography>
              </Grid>
            </Fragment>
          )}
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <CancelButton
              onClick={handleClose}
              variant="outlined"
              color="primary"
            >
              Cancel
            </CancelButton>
          </Grid>

          <Grid item xs />

          {otpSent ? (
            <Fragment>
              <Grid item>
                <PrimaryLoadingButton
                  loading={loading.resend}
                  variant="outlined"
                  onClick={resendOTP}
                  color="primary"
                >
                  Resend OTP
                </PrimaryLoadingButton>
              </Grid>

              <Grid item>
                <PrimaryLoadingButton
                  disabled={otpValue.length < 6}
                  loading={loading.verify}
                  variant="contained"
                  color="primary"
                  onClick={verificationOTP}
                >
                  Verify OTP
                </PrimaryLoadingButton>
              </Grid>
            </Fragment>
          ) : (
            <Grid item>
              <PrimaryLoadingButton
                disabled={aadharNumber?.toString().length < 12}
                loading={loading.send}
                variant="contained"
                color="primary"
                onClick={handleSendOtp}
              >
                Send OTP
              </PrimaryLoadingButton>
            </Grid>
          )}
        </Grid>
      </DialogActions>
    </StyledDialog>
  );

  function handleSendOtp() {
    setLoading({ ...loading, send: true });

    axios({
      url: "/send/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        setMessage(response.data.message);
        if (response?.data?.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: response.data.message,
            })
          );
        }

        //If OTP is generated immediately for the second time ,
        //after the first successful generation

        if (response?.data?.code === "422028") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        if (response?.data?.code === "422005") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //IF WRONG AADHAAR NO IS ENTERED

        if (response?.data?.code === "422007") {
          dispatch(
            alert({
              type: "warning",
              message: response.data.message,
            })
          );
        }

        //IF AADHAAR NO IS NOT LINKED WITH MOBILE NO

        if (response?.data?.code === "422008") {
          dispatch(
            alert({
              type: "warning",
              message: response.data.message,
            })
          );
        }

        //HASH MISMATCH
        if (response?.data?.code === "470028") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //HASH PARAMETER NOT PROVIDED
        if (response?.data?.code === "470053") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //AADHAAR PARAMETER NOT PROVIDEd
        if (response?.data?.code === "470050") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //FLUCTUATIONS AT UIDAI SIDE
        if (response?.data?.code === "471007") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //fetching xml from uiadi end
        if (response?.data?.code === "333") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //CLIENT PARAMETER NOT PROVIDED MEAN
        if (response?.data?.code === "470046") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }
        setLoading({ ...loading, resend: false });
        setOtpSent(true);
      }
    });
  }

  function verificationOTP() {
    setLoading({ ...loading, verify: true });
    axios({
      url: "/verify/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
        otp: parseInt(otpValue),
      },
    }).then((response) => {
      if (response.status) {
        setMessage(response.data.message);

        if (response?.data?.code === "000") {
          formikProps.setValues((prev) => ({
            ...prev,
            verifyNumber: true,
            otp: "",
          }));
          setSignLoading({ 1: true });
          axios({
            url: "/sign/company/agreement?type=COMPANY_REGISTRATION",
            method: "POST",
            data: {
              company_id: formikProps.values?.ID,
              type: "COMPANY_REGISTRATION",
              signed: true,
            },
          }).then((response) => {
            if (response.status) {
              setStep(2);

              formikProps.setValues((prev) => ({
                ...prev,
                viewAgreement: response.data,
              }));

              dispatch(
                alert({
                  type: "success",
                  message: "Agreement was successfully signed",
                })
              );

              setSignLoading({ 1: false });
            }
          });

          dispatch(
            alert({
              type: "success",
              message: "Aadhar Verified Successfully",
            })
          );
          setVerifyOTP(false);
        }

        //IF WRONG OTP IS ENTERED
        if (response.data?.code === "422002") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //If wrong OTP is entered for the fourth time
        if (response.data?.code === "422004") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //TXN ALREADY COMPLETED- After successful XML fetch, if the same UUID is used , the same / different OTP is used.
        if (response.data?.code === "470048") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }

        //If wrong UUID is passed
        if (response.data?.code === "470081") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
        if (response.data?.code === "333") {
          dispatch(
            alert({
              type: "error",
              message: response.data.message,
            })
          );
        }
      }

      setLoading({ ...loading, verify: false });
    });
  }

  function resendOTP() {
    setLoading({ ...loading, resend: true });

    axios({
      url: "/send/aadhar/otp",
      method: "POST",
      disableRedirect: true,
      data: {
        aadhar_number: parseInt(aadharNumber),
        user_id: parseInt(userID),
        msg_type: "agreement",
        brand_id: parseInt(brandID),
      },
    }).then((response) => {
      if (response.status) {
        if (response?.data?.code === "000") {
          dispatch(
            alert({
              type: "success",
              message: response.data.message,
            })
          );
        }

        //If OTP is generated immediately for the second time ,
        //after the first successful generation

        if (response?.data?.code === "422028") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        if (response?.data?.code === "422005") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //IF WRONG AADHAAR NO IS ENTERED

        if (response?.data?.code === "422007") {
          dispatch(
            alert({
              type: "warning",
              message: response.data.message,
            })
          );
        }

        //IF AADHAAR NO IS NOT LINKED WITH MOBILE NO

        if (response?.data?.code === "422008") {
          dispatch(
            alert({
              type: "warning",
              message: response.data.message,
            })
          );
        }

        //HASH MISMATCH
        if (response?.data?.code === "470028") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //HASH PARAMETER NOT PROVIDED
        if (response?.data?.code === "470053") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //AADHAAR PARAMETER NOT PROVIDEd
        if (response?.data?.code === "470050") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //FLUCTUATIONS AT UIDAI SIDE
        if (response?.data?.code === "471007") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //fetching xml from uiadi end
        if (response?.data?.code === "333") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }

        //CLIENT PARAMETER NOT PROVIDED MEAN
        if (response?.data?.code === "470046") {
          dispatch(
            alert({
              type: "info",
              message: response.data.message,
            })
          );
        }
        setLoading({ ...loading, resend: false });

        setOtpSent(true);
      }
    });
  }
}
